import * as React from "react";
import { updateCouponButtonPosition } from "./helpers";
import { debounce } from "debounce-decorator";
import { CouponButtonPosition } from "../../../../Typings";
export class CreateCouponBtn extends React.PureComponent {
    constructor(props) {
        super(props);
        this.couponBtnRef = React.createRef();
        this.setDimensionsBound = debounce(this.setDimensions, 10).bind(this);
        this.wrapperElement = window;
        this.topOffset = 0;
    }
    setDimensions() {
        const parent = this.props.parentRef.current;
        const child = this.couponBtnRef.current;
        if (child && parent) {
            updateCouponButtonPosition(child, parent, this.topOffset);
        }
    }
    componentDidMount() {
        if (this.props.cuponPosition === CouponButtonPosition.Fixed) {
            this.setDimensions();
            if (this.props.deviceType.isTablet) {
                this.wrapperElement = this.props.wrapEl;
                this.topOffset = this.props.tabletTopOffSet;
            }
            this.wrapperElement.addEventListener("resize", this.setDimensionsBound);
            this.wrapperElement.addEventListener("scroll", this.setDimensionsBound);
            // "btn-is-fixed";
        }
        // "btn-is-not-fixed";
    }
    componentWillUnmount() {
        this.wrapperElement.removeEventListener("resize", this.setDimensionsBound);
        this.wrapperElement.removeEventListener("scroll", this.setDimensionsBound);
    }
    render() {
        return (React.createElement("div", { className: "rj-league-list__coupon-btn-wrap", ref: this.couponBtnRef, "data-uat": "div-league-list-coupon" },
            React.createElement("button", { className: "rj-league-list__coupon-btn-content", onClick: (e) => this.props.onClick(this.props.sportId, e), "data-uat": "button-league-list-coupon" },
                this.props.label,
                " (",
                this.props.count,
                ")")));
    }
}
//# sourceMappingURL=CreateCouponBtn.js.map